import { render, staticRenderFns } from "./TakipAcTebligatGideriForm.vue?vue&type=template&id=26209f36&scoped=true"
import script from "./TakipAcTebligatGideriForm.vue?vue&type=script&lang=ts"
export * from "./TakipAcTebligatGideriForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26209f36",
  null
  
)

export default component.exports